import { useState } from "react";
import { categories } from "@/mocks/hoobuyData";

const categoryImages: Record<string, string> = {
  "911": "https://readdy.ai/api/search-image?query=Single%20designer%20running%20sneaker%20with%20red%20sole%20displayed%20on%20light%20grey%20concrete%20block%2C%20harsh%20top%20studio%20lighting%2C%20sharp%20shadows%2C%20minimalist%20product%20photography%2C%20industrial%20aesthetic%2C%20no%20text&width=800&height=560&seq=cat-v3-911&orientation=landscape",
  "912": "https://readdy.ai/api/search-image?query=Oversized%20designer%20hoodie%20draped%20casually%20over%20a%20dark%20walnut%20stool%2C%20side%20natural%20window%20light%2C%20textile%20texture%20richly%20detailed%2C%20editorial%20fashion%20photography%2C%20warm%20neutral%20background%2C%20no%20text&width=800&height=560&seq=cat-v3-912&orientation=landscape",
  "913": "https://readdy.ai/api/search-image?query=Premium%20white%20cotton%20t-shirt%20folded%20neatly%20on%20grey%20slate%20surface%2C%20angled%20afternoon%20light%2C%20subtle%20fabric%20weave%20visible%2C%20luxury%20minimal%20product%20photography%2C%20no%20text&width=800&height=560&seq=cat-v3-913&orientation=landscape",
};

const categoryGroupImages: Record<string, string> = {
  "cat-jackets": "https://readdy.ai/api/search-image?query=Vintage%20style%20leather%20biker%20jacket%20hanging%20on%20rustic%20wooden%20hanger%20against%20exposed%20brick%20wall%2C%20warm%20spotlight%2C%20textured%20leather%20details%2C%20editorial%20fashion%20photography%2C%20no%20text&width=800&height=520&seq=cat-v3-jackets&orientation=landscape",
  "cat-pants": "https://readdy.ai/api/search-image?query=Tailored%20designer%20trousers%20laid%20flat%20on%20polished%20concrete%20floor%2C%20overhead%20soft%20lighting%2C%20premium%20fabric%20texture%2C%20minimalist%20editorial%20style%2C%20no%20text&width=800&height=520&seq=cat-v3-pants&orientation=landscape",
  "cat-headwear": "https://readdy.ai/api/search-image?query=Designer%20baseball%20cap%20with%20subtle%20embroidery%20resting%20on%20white%20ceramic%20pedestal%2C%20gallery%20spotlight%20effect%2C%20clean%20minimal%20product%20photography%2C%20dark%20background%2C%20no%20text&width=800&height=520&seq=cat-v3-headwear&orientation=landscape",
  "cat-sets": "https://readdy.ai/api/search-image?query=Matching%20designer%20hoodie%20and%20jogger%20set%20displayed%20on%20minimal%20mannequin%20torso%2C%20studio%20lighting%20with%20soft%20shadows%2C%20editorial%20fashion%20photography%2C%20grey%20backdrop%2C%20no%20text&width=800&height=520&seq=cat-v3-sets&orientation=landscape",
  "cat-underwear": "https://readdy.ai/api/search-image?query=Premium%20cotton%20underwear%20folded%20on%20white%20linen%20fabric%2C%20morning%20natural%20light%2C%20clean%20hygienic%20aesthetic%2C%20minimal%20product%20photography%2C%20no%20text&width=800&height=520&seq=cat-v3-underwear&orientation=landscape",
  "cat-jersey": "https://readdy.ai/api/search-image?query=Professional%20sports%20jersey%20with%20bold%20colors%20displayed%20on%20dark%20locker%20room%20bench%2C%20dramatic%20overhead%20lighting%2C%20athletic%20editorial%20style%2C%20no%20text&width=800&height=520&seq=cat-v3-jersey&orientation=landscape",
  "cat-accessories": "https://readdy.ai/api/search-image?query=Luxury%20sunglasses%20and%20gold%20chain%20necklace%20arranged%20on%20black%20velvet%20surface%2C%20soft%20ring%20light%2C%20reflective%20details%2C%20high%20end%20product%20photography%2C%20no%20text&width=800&height=520&seq=cat-v3-accessories&orientation=landscape",
  "cat-bags": "https://readdy.ai/api/search-image?query=Designer%20crossbody%20bag%20in%20cognac%20leather%20on%20white%20display%20shelf%2C%20angled%20spotlight%2C%20gold%20hardware%20details%20visible%2C%20luxury%20editorial%20photography%2C%20no%20text&width=800&height=520&seq=cat-v3-bags&orientation=landscape",
  "cat-belts": "https://readdy.ai/api/search-image?query=Italian%20leather%20belt%20with%20polished%20buckle%20coiled%20on%20white%20marble%2C%20morning%20sunlight%20from%20left%2C%20premium%20texture%20visible%2C%20minimal%20product%20photography%2C%20no%20text&width=800&height=520&seq=cat-v3-belts&orientation=landscape",
  "cat-perfumes": "https://readdy.ai/api/search-image?query=Glass%20perfume%20bottle%20with%20amber%20liquid%20on%20dark%20slate%20surface%20with%20reflection%2C%20dramatic%20backlighting%2C%20luxury%20fragrance%20photography%2C%20no%20text&width=800&height=520&seq=cat-v3-perfumes&orientation=landscape",
  "cat-other": "https://readdy.ai/api/search-image?query=Mixed%20luxury%20fashion%20small%20items%20including%20keychain%20wallet%20and%20card%20holder%20on%20white%20surface%2C%20soft%20diffused%20lighting%2C%20editorial%20flat%20lay%2C%20no%20text&width=800&height=520&seq=cat-v3-other&orientation=landscape",
  "cat-all": "https://readdy.ai/api/search-image?query=Curated%20collection%20of%20various%20luxury%20fashion%20items%20including%20sneakers%20bag%20and%20accessories%20on%20light%20oak%20table%2C%20natural%20daylight%2C%20editorial%20style%2C%20no%20text&width=800&height=520&seq=cat-v3-all&orientation=landscape",
};

const categoryGroups = [
  {
    title: "Categorias",
    subtitle: "Populares",
    items: [
      { name: "Jackets", url: "https://kaspreadsheet.com/search-914/name/Shoes.html", imageSeq: "cat-jackets" },
      { name: "Pants/Shorts", url: "https://kaspreadsheet.com/search-915/name/Shoes.html", imageSeq: "cat-pants" },
      { name: "Headwear", url: "https://kaspreadsheet.com/search-916/name/Shoes.html", imageSeq: "cat-headwear" },
    ]
  },
  {
    title: "Mais",
    subtitle: "Categorias",
    items: [
      { name: "Sets", url: "https://kaspreadsheet.com/search-917/name/Shoes.html", imageSeq: "cat-sets" },
      { name: "Underwear", url: "https://kaspreadsheet.com/search-918/name/Shoes.html", imageSeq: "cat-underwear" },
      { name: "Jersey", url: "https://kaspreadsheet.com/search-919/name/Shoes.html", imageSeq: "cat-jersey" },
    ]
  },
  {
    title: "Acessórios",
    subtitle: "Essenciais",
    items: [
      { name: "Accessories", url: "https://kaspreadsheet.com/search-920/name/Shoes.html", imageSeq: "cat-accessories" },
      { name: "Bags", url: "https://kaspreadsheet.com/search-921/name/Shoes.html", imageSeq: "cat-bags" },
      { name: "Belts", url: "https://kaspreadsheet.com/search-922/name/Shoes.html", imageSeq: "cat-belts" },
    ]
  },
  {
    title: "Outros",
    subtitle: "Produtos",
    items: [
      { name: "Perfumes", url: "https://kaspreadsheet.com/search-923/name/Shoes.html", imageSeq: "cat-perfumes" },
      { name: "Other Stuff", url: "https://kaspreadsheet.com/search-924/name/Shoes.html", imageSeq: "cat-other" },
      { name: "Todos os Produtos", url: "https://kaspreadsheet.com/category-911-Shoes.html", imageSeq: "cat-all" },
    ]
  },
];

export default function CategorySection() {
  const [selectedCategory, setSelectedCategory] = useState("");

  const handleDropdownChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const url = e.target.value;
    if (url) {
      const newWindow = window.open(url, "_blank");
      if (newWindow) {
        newWindow.opener = null;
      }
    }
  };

  return (
    <section id="categories" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="flex flex-col lg:flex-row lg:items-start lg:justify-between gap-6 mb-12">
          <div>
            <h2 className="text-3xl md:text-4xl font-bold font-heading text-foreground-950">
              Navegue por Categoria
            </h2>
            <p className="mt-2 text-base text-foreground-500">
              e Encontre as Melhores Ofertas
            </p>
          </div>
          <div className="w-full lg:w-[320px]">
            <select
              value={selectedCategory}
              onChange={handleDropdownChange}
              className="w-full px-5 py-3.5 rounded-lg bg-background-50 border border-background-300 text-sm text-foreground-700 font-medium cursor-pointer appearance-none bg-[url('data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2220%22%20height%3D%2220%22%20viewBox%3D%220%200%2024%2024%22%3E%3Cpath%20d%3D%22M12%2016l-6-6h12z%22%20fill%3D%22%23555%22%2F%3E%3C%2Fsvg%3E')] bg-[length:20px] bg-[right_12px_center] bg-no-repeat focus:outline-none focus:ring-2 focus:ring-primary-300"
            >
              <option value="">Selecione uma categoria...</option>
              {categories.map((cat) => (
                <option key={cat.searchId} value={cat.url}>
                  {cat.name}
                </option>
              ))}
            </select>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 mb-14">
          {categories.slice(0, 3).map((cat) => (
            <a
              key={cat.searchId}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group block rounded-lg overflow-hidden bg-background-50 border border-background-200/70 cursor-pointer hover:border-primary-200 transition-all duration-300"
            >
              <div className="h-48 md:h-56 overflow-hidden">
                <img
                  src={categoryImages[cat.searchId] || categoryImages["911"]}
                  alt={cat.name}
                  title={`${cat.name} - Hoobuy Spreadsheet`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-5">
                <h3 className="text-lg font-bold font-heading text-foreground-950">
                  {cat.name}
                </h3>
                <p className="mt-1 text-sm text-foreground-500">
                  Links verificados atualizados diariamente
                </p>
              </div>
            </a>
          ))}
        </div>

        {categoryGroups.map((group, idx) => (
          <div key={idx} className="mb-12">
            <div className="mb-6">
              <h3 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950">
                {group.title}
              </h3>
              <p className="text-base text-foreground-500 font-serif italic">
                {group.subtitle}
              </p>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-5">
              {group.items.map((item) => (
                <a
                  key={item.imageSeq}
                  href={item.url}
                  target="_blank"
                  rel="noopener nofollow"
                  className="group block rounded-lg overflow-hidden bg-background-50 border border-background-200/70 cursor-pointer hover:border-primary-200 transition-all duration-300"
                >
                  <div className="h-44 md:h-52 overflow-hidden">
                    <img
                      src={categoryGroupImages[item.imageSeq] || categoryGroupImages["cat-all"]}
                      alt={item.name}
                      title={`${item.name} - Hoobuy Spreadsheet Brasil`}
                      className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                    />
                  </div>
                  <div className="p-4">
                    <h4 className="text-base font-semibold font-heading text-foreground-950">
                      {item.name}
                    </h4>
                  </div>
                </a>
              ))}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}